import {useCallback,memo} from 'react'

//styles
import 'devextreme/dist/css/dx.light.css';
import '../../styles/input/custom-input.css'

//components
import { TextBox } from 'devextreme-react/text-box';

import {
    Validator,
    RequiredRule,
    EmailRule
  } from 'devextreme-react/validator';

const CustomEmail = ({label, value, setValue,requiredValue,labelSize,isDisabled,reference}) => {
  const onChangeValue = useCallback((data) => {
      setValue(data)
  }, []);
  const onKeyValidation = useCallback(e=>{
    let regex = /[<>]/
    regex.test(e.event.key) && e.event.preventDefault()
  },[])
  
  return (
    <div className='custom-input' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
        <div className='custom-input__label'>{label}:{requiredValue ? <span>*</span> : ''}</div>
        <TextBox
          value={value}
          disabled={isDisabled}
          valueChangeEvent="input"
          onValueChange={onChangeValue}
          onKeyDown={onKeyValidation}
        >
          {requiredValue &&
            <Validator
              ref={reference}
            >
              <RequiredRule message={`${label} is required`} />
              <EmailRule message="The email must have a correct format" />
            </Validator>
          }
        </TextBox>
    </div>
  )
}

export default memo(CustomEmail)